<script lang="ts" setup>
import type { ConfigProviderThemeVars } from '@wot-ui/ui'
// 仅本 layout 使用，不走 easycom，手动引入（放 layouts 下会被插件多注册为一个无引用的 layout，无实际影响）
import CustomTabbar from './custom-tabbar.vue'

const themeVars: ConfigProviderThemeVars = {
  buttonPrimaryBg: '#0072E6',
  // buttonPrimaryColor: '#0072E6',
}
</script>

<template>
  <wd-config-provider :themeVars="themeVars">
    <slot />
    <!-- 自定义 tabbar：组件内部判断当前页是否 tab 页，非 tab 页不渲染 -->
    <custom-tabbar />
  </wd-config-provider>
</template>
